export const GET_COMMUNICATION_METHODS = 'GET_COMMUNICATION_METHODS';
export const SET_COMMUNICATION_METHODS = 'SET_COMMUNICATION_METHODS';
export const GET_COMMUNICATION_METHODS_ERROR = 'GET_COMMUNICATION_METHODS_ERROR';
